import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import ModalSmallFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'

interface ModalChangeActiveServiceProps extends ModalEditComponentProps { }

const ModalChangeActiveService: React.FC<ModalChangeActiveServiceProps> = ({ setOpened, onSubmit, allRowData }) => {
    if (allRowData?.active === false) {
        return <ModalReactivateService {...{ setOpened, onSubmit, allRowData }} />
    } else {
        return <ModalDeleteService {...{ setOpened, onSubmit, allRowData }} />
    }
}


interface ModalReactivateServiceProps extends ModalEditComponentProps { }

const ModalReactivateService: React.FC<ModalReactivateServiceProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/product/updateProduct',
        data: {
            id: allRowData?.id,
            active: true
        }
    })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureReactiveThisService', '¿Seguro que quieres reactivar este servicio?'),
            subtitle: t('onceReactivatedAbleInServiceList', 'Una vez reactivado volverá a aparecer en el listado de servicios'),
            buttonAccept: t('reactivate', 'Reactivar')
        }} />
    )
}


interface ModalDeleteServiceProps extends ModalEditComponentProps { }

const ModalDeleteService: React.FC<ModalDeleteServiceProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/product/deleteProduct',
        data: {
            id: allRowData?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureUnableService', '¿Seguro que quieres desactivar este servicio?'),
            subtitle: t('onceUnabledCouldBeRecovered', 'Una vez desactivado se podrá reactivar de nuevo'),
            buttonAccept: t('unable', 'Desactivar')
        }} />
    )
}

export default ModalChangeActiveService